import { Box, Grid2 } from '@mui/material';
import { ActualAuctionStatusEnum } from '../../_common/enum/actualAuctionStatus';
import { getActualStatus } from '../../_helpers/auction.helper';
import { CatalogueItemOnlineCard } from './components/auction-catalogueItemOnlineCard';
import { CatalogueItemStatusCard } from './components/auction-catalogueItemStatusCard';
import { AuctionCatalogueItemUserBid } from './components/auction-catalogueItemUserBid';
import { AuctionCatalogueItemView } from './components/auction-catalogueItemView';
import { AuctionCatalogueList } from './components/auction-catalogueList';
import { AuctionMessages } from './components/auction-messages';
import { useAuctionUser } from '../../_hubs/auctionUser.hub';

export function AuctionUserIndex(params: {
    auction: any,
    catalogueItem: any,
    catalogueItemLoading: boolean,
    statusSyncPending?: boolean,
    onResyncFromServer?: () => void,
}) {

    const { presence, socketLive } = useAuctionUser(params.onResyncFromServer);
    const connectionUnknown = !socketLive || !!params.statusSyncPending;
    const hideAuctionStatus = connectionUnknown;
    const serverStatus = getActualStatus(params.auction, params.catalogueItem);
    const actualStatus = hideAuctionStatus ? ActualAuctionStatusEnum.Pending : serverStatus;

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
                gridTemplateColumns: { xs: '1fr', sm: '1fr 2fr 1fr' },
                gridTemplateRows: { xs: 'auto', sm: 'auto auto auto' },
            }}
        >
            <Box sx={{ order: { xs: 1, sm: 0 }, gridColumn: { sm: '2' }, gridRow: { sm: '1' }, minWidth: 0 }}>
                <Box sx={{ mb: 1 }}>
                    <CatalogueItemOnlineCard presence={presence} />
                </Box>
                {!hideAuctionStatus &&
                    <CatalogueItemStatusCard catalogueItem={params.catalogueItem} actualAuctionStatusId={serverStatus} />
                }
            </Box>
            <Box sx={{ order: { xs: 2, sm: 0 }, gridColumn: { sm: '2' }, gridRow: { sm: '2' }, minWidth: 0 }}>
                <AuctionCatalogueItemView catalogueItem={params.catalogueItem} catalogueItemLoading={params.catalogueItemLoading} />
            </Box>
            <Box sx={{ order: { xs: 3, sm: 0 }, gridColumn: { sm: '3' }, gridRow: { sm: '1 / -1' }, minWidth: 0 }}>
                <AuctionCatalogueItemUserBid catalogueItemLoading={params.catalogueItemLoading} catalogueItem={params.catalogueItem} actualAuctionStatusId={actualStatus} />
            </Box>
            <Box sx={{ order: { xs: 4, sm: 0 }, gridColumn: { sm: '2' }, gridRow: { sm: '3' }, minWidth: 0 }}>
                <AuctionMessages catalogueId={params.catalogueItem?.catalogueId} />
            </Box>
            <Box sx={{ order: { xs: 5, sm: 0 }, gridColumn: { sm: '1' }, gridRow: { sm: '1 / -1' }, minWidth: 0 }}>
                <AuctionCatalogueList auction={params.auction} catalogueItem={params.catalogueItem} actualAuctionStatusId={actualStatus} />
            </Box>
        </Box>
    );
}
